module.exports = __webpack_public_path__ + "static/media/img-dentist-product-5.288356ca.png";